<template>
    <el-dialog title="上传课件" :visible="isShowUpload" width="864px" top="5%" @close="closeDialog" v-loading.lock="uploading">
        <slot name="header"></slot>
        <!-- <div class="upload-info">
            <el-button size="small" type="primary" @click="submitUploads">确认上传</el-button>
            <div>
                <span class="shezhi">设置发布时间 :</span>
                <el-date-picker size="small" v-model="times" type="datetime" placeholder="选择日期时间" default-time="12:00:00"
                    value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" @change="dateChnage">
                </el-date-picker>
            </div>
        </div> -->
        <el-upload v-loading.lock="loading" class="upload-demo" ref="uploadFile" :disabled="files.length > 6" drag
            action="#" :limit="6" multiple accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .png, .jpg, .jpeg, .txt"
            :on-exceed="onExceed" :http-request="httpRequest">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__text">单次最多可上传六条</div>
        </el-upload>
        <div slot="footer" class="footer">
            <el-button :disabled="files.length === 0" type="primary" @click="submitUploads">确认上传</el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        isShowUpload: {
            type: Boolean,
            require: true,
            default: true,
        },
        uploading: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            times: '',
            files: [], // 存储上传的文件
            timer: '',
            loading: false
        }
    },
    mounted () {
        this.nowTime()
        this.timer = setInterval(() => {
            this.nowTime()
        }, 50000)
    },
    methods: {
        // 获取当前时间
        nowTime () {
            // var date = new Date();
            const dt = new Date()

            const y = dt.getFullYear()
            //padStart(2,0)   第一个参数是一共几个字符，第二个是补全字符    字符串补全功能  头部补全
            //padEnd     尾部补全
            const m = (dt.getMonth() + 1 + '').padStart(2, '0')
            const d = (dt.getDate() + '').padStart(2, '0')

            const hh = (dt.getHours() + '').padStart(2, '0')
            const mm = (dt.getMinutes() + '').padStart(2, '0')
            this.times = `${y}-${m}-${d} ${hh}:${mm}`
        },
        // 关闭弹窗
        closeDialog () {
            this.$emit('closeDialog')
        },
        // 日期切换
        dateChnage () {
            clearInterval(this.timer)
        },
        // upload上传文件
        httpRequest (parmas) {
            this.loading = true
            // 文件大小
            let fileSize = Number(parmas.file.size / 1024 / 1024)
            // 上传的文件
            let uploadFiles = this.$refs['uploadFile'].uploadFiles

            // 查找文件下标
            const idx = this.$refs.uploadFile.uploadFiles.findIndex(item => item.uid === parmas.file.uid)
            // this.$set(uploadFiles[idx], 'status', 'error')
            if (fileSize > 128) {
                this.$msgbox({
                    title: "",
                    message: "文件大小不能超过128MB，请重新上传。",
                    type: "warning",
                })
                uploadFiles.splice(idx, 1)
                this.loading = false
                return false
            }

            this.loading = false
            this.files = uploadFiles
        },
        // 超出文件上传个数
        onExceed () {
            this.$message.warning('超出文件上传个数')
        },

        // 确认上传文件
        submitUploads () {
            this.$emit('submitFile', this.files)
        }
    }

}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
    position: relative;
    height: 630px;

    .upload-info {
        margin-bottom: 20px;
    }


    .el-dialog__footer {
        position: absolute;
        bottom: 20px;
        left: 35%;

        .el-button {
            width: 100px;
        }
    }
}



/deep/ .is-error .el-upload-list__item-status-label {
    display: inline-block;
}

/deep/ .is-error .el-icon-circle-check::before {
    display: inline-block;
    content: '\E7A3';
    color: #f00;
}

/deep/ .is-error:hover .el-upload-list__item-status-label {
    display: none;
}

/deep/ .el-upload-dragger {
    width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/kejian/components/Upload.vue